import { IListarCasoRequest } from "../../../Interfaces/Vendas/Caso/CasoInterface";
import {
    IContactListItem,
    ILeadRequest,
    ILeadTag,
    ILeadTagRequest,
} from "../../../Interfaces/Vendas/Lead/LeadInterface";
import AxiosVendas from "../../Config/ApiVendas";
import Service from "../../Service";

export async function VendasLeadPostService(requestBody: ILeadRequest) {
    return Service(AxiosVendas.post(`/app/lead`, requestBody));
}

export async function VendasLeadGetService(idLead: number) {
    return Service(AxiosVendas.get<ILeadRequest>(`/app/lead?idLead=${idLead}`));
}

export async function VendasLeadPutService(requestBody: ILeadRequest) {
    return Service(AxiosVendas.put(`/app/lead`, requestBody));
}

export async function VendasListarTagsService(idLead: number) {
    return Service(
        AxiosVendas.get<Array<ILeadTag>>(
            `/app/lead/listartags?idLead=${idLead}`
        )
    );
}

export async function VendasInserirTagsService(requestBody: ILeadTagRequest) {
    return Service(AxiosVendas.post(`/app/lead/inserirtag`, requestBody));
}

export async function VendasDeletarTagService(idLead: number, dsTag: string) {
    return Service(
        AxiosVendas.delete(
            `/app/lead/deletartag?idLead=${idLead}&dsTag=${dsTag}`
        )
    );
}

export async function VendasListarContatosService(idLead: number) {
    return Service(
        AxiosVendas.post<Array<IContactListItem>>(
            `/app/lead/listarcontatos?idLead=${idLead}`
        )
    );
}

export async function VendasInserirContatoService(
    requestBody: IContactListItem
) {
    return Service(AxiosVendas.put(`/app/lead/inserircontato`, requestBody));
}

export async function TransferirLeadsEmMassaService(
    ID_RESPONSAVEL_DESTINO: number,
    requestBody: IListarCasoRequest
) {
    return Service(
        AxiosVendas.put(
            `/app/lead/transferirleadsemmassa?ID_RESPONSAVEL_DESTINO=${ID_RESPONSAVEL_DESTINO}`,
            requestBody
        )
    );
}
